import type { IconNode } from '../types';

/**
 * @name baseball
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxMmM1LjUgMCAxMC00LjUgMTAtMTAiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiIC8+CiAgPHBhdGggZD0iTTIyIDEyYy01LjUgMC0xMCA0LjUtMTAgMTAiIC8+CiAgPHBhdGggZD0ibTggMTEuNS0xLjUtMiIgLz4KICA8cGF0aCBkPSJtMTEuNSA4LTItMS41IiAvPgogIDxwYXRoIGQ9Im0xNC41IDE3LjUtMi0xLjUiIC8+CiAgPHBhdGggZD0ibTE3LjUgMTQuNS0xLjUtMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/baseball
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const baseball: IconNode = [
  ['path', { d: 'M2 12c5.5 0 10-4.5 10-10', key: '179xs2' }],
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M22 12c-5.5 0-10 4.5-10 10', key: 'gdzvca' }],
  ['path', { d: 'm8 11.5-1.5-2', key: 'i1ydf0' }],
  ['path', { d: 'm11.5 8-2-1.5', key: '8b6wdo' }],
  ['path', { d: 'm14.5 17.5-2-1.5', key: 'q26rn0' }],
  ['path', { d: 'm17.5 14.5-1.5-2', key: '10rs74' }],
];

export default baseball;
